import { render, staticRenderFns } from "./importance-de-lhebergement-web.vue?vue&type=template&id=b111f680&"
import script from "./importance-de-lhebergement-web.vue?vue&type=script&lang=js&"
export * from "./importance-de-lhebergement-web.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports